import { supabase } from '../supabaseClient';

export async function askCopilot(caseId, messages) {
  const { data, error } = await supabase.functions.invoke('case-copilot', {
    body: { caseId, messages },
  });

  if (error) throw error;
  if (data?.error) throw new Error(data.error);

  return data.reply;
}